import { render, staticRenderFns } from "./CustomersAddItemDialog.vue?vue&type=template&id=56bea72b"
import script from "./CustomersAddItemDialog.vue?vue&type=script&lang=js"
export * from "./CustomersAddItemDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports